
<template>
  <!-- Riepilogo delle scelte della campagna selezionata -->
  <b-card class="mt-3 mr-1 ml-1">
    <b-row>
      <!-- Numero di risposte ricevute -->
      <b-col cols="12" md="4" class="mb-3 mb-md-0">
        <b-card bg-variant="light" class="h-100 text-center">
          <div class="text-muted mb-2">Risposte ricevute</div>
          <h4 class="mb-0">{{ risposte_ricevute }} di {{ totale_premi }}</h4>
        </b-card>
      </b-col>

      <!-- Totale convertito in welfare -->
      <b-col cols="12" md="4" class="mb-3 mb-md-0">
        <b-card bg-variant="light" class="h-100 text-center">
          <div class="text-muted mb-2">Totale convertito in welfare</div>
          <h4 class="mb-0">{{ formatImporto(totale_welfare) }}</h4>
        </b-card>
      </b-col>

      <!-- Totale destinato alla busta paga -->
      <b-col cols="12" md="4">
        <b-card bg-variant="light" class="h-100 text-center">
          <div class="text-muted mb-2">Totale destinato alla busta paga</div>
          <h4 class="mb-0">{{ formatImporto(totale_busta_paga) }}</h4>
        </b-card>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
export default {
  name: "CPRiepilogo",

  props: {
    // Dati originali recuperati dal backend, senza modifiche non salvate.
    dipendenti_premi: { type: Array, required: true }
  },

  computed: {

    // Conta i dipendenti con un premio assegnato.
    totale_premi() {
      return this.dipendenti_premi.filter(
        dipendente => Number(dipendente.valore) > 0
      ).length;
    },

    // Conta le scelte attive ricevute.
    risposte_ricevute() {
      return this.dipendenti_premi.filter(
        dipendente =>
          Number(dipendente.valore) > 0 &&
          ["WELFARE", "BUSTA_PAGA"].includes(dipendente.scelta)
      ).length;
    },

    // Somma il welfare dei dipendenti che hanno scelto WELFARE.
    totale_welfare() {
      return this.dipendenti_premi.reduce((totale, dipendente) => {
        if (dipendente.scelta !== "WELFARE") return totale;
        return totale + Number(dipendente.welfare || 0);
      }, 0);
    },

    // Somma i premi lordi dei dipendenti che hanno scelto BUSTA_PAGA.
    totale_busta_paga() {
      return this.dipendenti_premi.reduce((totale, dipendente) => {
        if (dipendente.scelta !== "BUSTA_PAGA") return totale;
        return totale + Number(dipendente.valore || 0);
      }, 0);
    }
  },

  methods: {
    // Formatta gli importi in euro.
    formatImporto(valore) {
      return Number(valore).toLocaleString("it-IT", {
        style: "currency",
        currency: "EUR",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    }
  }
};
</script>
